<template>
  <c-modal
    v-model="modal"
    size="md"
    centered
    no-fade
    :tag="false"
    title="Delete Item Confirmation"
    confirm-label="Yes, Delete Item"
    cancel-label="No, Never mind"
    :progressing="progressing"
    @submit="submit"
    @show="showModal"
  >
    <template>
      Are you sure you want to delete {{food.Name}}?
      <div class="mt-3">
        <b-form-checkbox
          v-model="deleteAll"
          :value="true"
          :unchecked-value="false"
        >
          Delete all "{{food.Name}}" in other categories and menus.
        </b-form-checkbox>
      </div>
    </template>
  </c-modal>
</template>

<script>
  import CModal from "../../../../shared/Cmodal";
  export default {
    name: "DeleteConfirmation",
    components: {CModal},
    props: {
      progressing: {
        type: Boolean,
        default: false
      },
      value: {
        required: true
      },
      food: {
        required: true,
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        deleteAll: false
      }
    },
    computed: {
      modal: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    methods: {
      showModal () {
        this.deleteAll = false
      },
      submit () {
        this.$emit('refresh', {food: this.food, deleteAll: this.deleteAll})
      }
    }
  }
</script>

<style scoped>

</style>
